import { RuntimeConfig } from 'config/config.types';
import { axiosInstance } from 'shared/axios/axiosConfig';

const getRuntimeConfig = async (): Promise<RuntimeConfig> => {
  const json = await axiosInstance.get(`/runtime-config`);

  return json.data;
};

const runtimeConfigService = { getRuntimeConfig };
export default runtimeConfigService;
